/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Button from '@atlaskit/button';
import { cssMap, jsx } from '@atlaskit/css';
import { IconTile } from '@atlaskit/icon';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	knowledgeBadge: {
		display: 'inline-flex',
		borderWidth: token('border.width', '1px'),
		borderColor: token('color.border'),
		borderStyle: 'solid',
		borderRadius: token('radius.small'),
	},
	buttonLink: {
		paddingTop: token('space.025'),
		paddingRight: token('space.025'),
		paddingBottom: token('space.025'),
		paddingLeft: token('space.025'),
		marginLeft: token('space.025'),
		marginRight: token('space.050'),
	},
});

interface KnowledgeBadgeProps {
	name: string;
	url?: string;
	onBadgeClick?: () => void;
}

export const KnowledgeBadge = ({ name, url, onBadgeClick = () => {} }: KnowledgeBadgeProps) => (
	<Box xcss={styles.knowledgeBadge} backgroundColor="color.background.input">
		<Button
			href={url}
			appearance="subtle"
			onClick={() => {
				onBadgeClick();
			}}
			spacing="none"
			target="_blank"
		>
			<Inline space="space.050" alignBlock="center" xcss={styles.buttonLink}>
				<IconTile icon={BookWithBookmarkIcon} label="" appearance="blue" size="16" />
				<Text>{name}</Text>
			</Inline>
		</Button>
	</Box>
);
